const userRoutes = [
  {
    path: '/host',
    name: 'host',
    component: () => import('@/views/user/invitations/SentView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/received',
    name: 'received',
    component: () => import('@/views/user/invitations/ReceivedView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/received/:slug',
    name: 'received-detail',
    component: () => import('@/views/user/invitations/ReceivedDetailView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/detail/:eventid',
    name: 'invitation-detail',
    component: () => import('@/views/user/invitations/InvitationDetailView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/create-invitation',
    name: 'create-invitation',
    component: () => import('@/views/user/invitations/AddInvitationView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/create-event',
    name: 'create-event',
    component: () => import('@/views/user/invitations/AddInvitationView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/edit-invitation/:eventid',
    name: 'edit-invitation',
    component: () => import('@/views/user/invitations/EditInvitationView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/event-settings/:eventid',
    name: 'event-settings',
    component: () => import('@/views/user/invitations/EventSettingsView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/detail/enquiry-list/:eventid',
    name: 'event-enquiries',
    component: () => import('@/views/user/invitations/EnquiriesList.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/detail/vendors/:eventid',
    name: 'event-hired-vendors',
    component: () => import('@/views/user/invitations/HiredVendorsView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/detail/vendors/add-vendor/:eventid',
    name: 'event-add-vendors',
    component: () => import('@/views/user/invitations/AddVendorsView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/detail/posts/:eventid',
    name: 'event-posts',
    component: () => import('@/views/user/invitations/EventPostsView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/send-enquiry/:eventid',
    name: 'send-enquiry',
    component: () => import('@/views/user/invitations/AddEnquiry.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/feedbacks/:eventid',
    name: 'feedbacks',
    component: () => import('@/views/user/invitations/Feedbacks.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/guest/:eventid',
    name: 'guest-list',
    component: () => import('@/views/user/invitations/AddGuestsView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/cohost/:eventid',
    name: 'cohost',
    component: () => import('@/views/user/invitations/CoHostView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/albums',
    name: 'albums',
    component: () => import('@/views/user/albums/AlbumsView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/albums/:eventid',
    alias: '/album/:eventid',
    name: 'album-detail',
    component: () => import('@/views/user/albums/AlbumsDetail.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/profile/:id',
    name: 'user-profile',
    component: () => import('@/views/user/invitations/Profile.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/my-contacts',
    name: 'my-contacts',
    component: () => import('@/views/user/settings/ContactsView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/user/settings/SettingsView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/update-profile',
    name: 'update-profile',
    component: () => import('@/views/user/settings/UpdateProfileView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/enquiries-list',
    name: 'enquiries-list',
    component: () => import('@/views/user/settings/EnquiriesView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('@/views/user/settings/ChangePasswordView.vue'),
    meta: { requiresAuth: true, layout: 'user', allowedRole: 'user' }
  }
]

export default userRoutes
